import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a3872a9a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3872a9a')) {
      api.createRecord('a3872a9a', component.options)
    } else {
      api.reload('a3872a9a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a3872a9a&", function () {
      api.rerender('a3872a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Hu7SuLd9NOnc/JS/comp/ImgFallback.vue"
export default component.exports